import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'feather-icons/dist/feather.min.js'
import './registerServiceWorker'


// global variable




var app = createApp(App).use(router);

app.config.globalProperties.vi_token = 'f8a20cbc217edc32127c28ba7df6a16b07593ff099c06f17f0be79841491f4b2';
app.config.globalProperties.vi_cid = '18322529597';
app.config.globalProperties.vi_sce = '33246';
app.config.globalProperties.vi_dom = 'kafeina';

app.mount('#app')
